import { useEffect, useState } from "react";

/**
 * Hook SSR-safe pra escutar media queries. Atualiza em resize, mudança de orientação, etc.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState<boolean>(() => {
    if (typeof window === "undefined") return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (typeof window === "undefined") return;
    const mq = window.matchMedia(query);
    const update = () => setMatches(mq.matches);
    mq.addEventListener("change", update);
    update();
    return () => mq.removeEventListener("change", update);
  }, [query]);

  return matches;
}

/** Convenience: breakpoint Tailwind `md` (768px). */
export function useIsMobile(): boolean {
  return useMediaQuery("(max-width: 767px)");
}
